<ng-container [ngSwitch]="data">
  <div *ngIf="data == '0'" i18n="@@common.postback">Postback</div>
  <div *ngIf="data == '1'" i18n="@@common.iframe_pixel">iFrame pixel</div>
</ng-container>
